import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const Svg2Personen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M13 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M13 18a6 6 0 0 1 6 6v10H7V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M18 13h1a4 4 0 0 1-8 0h1a3 3 0 1 0 6 0m0 0h1a4 4 0 0 1-8 0h1a3 3 0 1 0 6 0M10.5 32h-1v-9h1z"
    />
    <path
      fill="#F170B8"
      d="M27 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M27 18a6 6 0 0 1 6 6v10H21V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M28 13h1a4 4 0 0 1-8 0h1a3 3 0 1 0 6 0m0 0h1a4 4 0 0 1-8 0h1a3 3 0 1 0 6 0M30.5 32h-1v-9h1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(Svg2Personen);

export default ForwardRef;
